import { useEffect, useState } from "react";
import api from "@/lib/api";

export const OS_STATUS_FLOW = ["DRAFT", "PRECHECK", "SUBMITTED", "UNDER_REVIEW", "DECIDED", "ARCHIVED"];

export const OS_TRANSITIONS = {
  DRAFT: ["PRECHECK", "SUBMITTED"],
  PRECHECK: ["DRAFT", "SUBMITTED"],
  SUBMITTED: ["UNDER_REVIEW"],
  UNDER_REVIEW: ["DECIDED"],
  DECIDED: ["ARCHIVED"],
  ARCHIVED: [],
};

export const OS_STATUS_STYLE = {
  DRAFT: "bg-zinc-100 text-zinc-700 border-zinc-200",
  PRECHECK: "bg-amber-50 text-amber-800 border-amber-200",
  SUBMITTED: "bg-blue-50 text-blue-800 border-blue-200",
  UNDER_REVIEW: "bg-indigo-50 text-indigo-800 border-indigo-200",
  DECIDED: "bg-emerald-50 text-emerald-800 border-emerald-200",
  ARCHIVED: "bg-zinc-100 text-zinc-500 border-zinc-200",
};

export const OS_STATUS_LABEL = {
  DRAFT: "Utkast", PRECHECK: "Förgranskning", SUBMITTED: "Inlämnat",
  UNDER_REVIEW: "Under granskning", DECIDED: "Beslutat", ARCHIVED: "Arkiverat",
};

export const OS_EVENT_LABEL = {
  CASE_CREATED: "Ärende skapat", DOCUMENT_UPLOADED: "Dokument uppladdat",
  PROPERTY_UPDATED: "Fastighet uppdaterad", SPATIAL_ANALYSIS_STARTED: "Spatial analys startad",
  STATUS_CHANGED: "Status ändrad", DECISION_MADE: "Beslut fattat", CASE_ASSIGNED: "Ärende tilldelat",
};

export const OS_DECISION_LABEL = { BEVILJAT: "Beviljat", AVSLAG: "Avslag", AVVISAT: "Avvisat" };

export const osDaysLeft = (dueDate) => Math.ceil((new Date(dueDate) - Date.now()) / 86400000);

export const OS_WRITE_ROLES = ["ADMIN", "HANDLAGGARE"];

export function useOsMe() {
  const [me, setMe] = useState(null);
  const [denied, setDenied] = useState(false);
  useEffect(() => {
    api.get("/os/me").then((r) => setMe(r.data)).catch(() => setDenied(true));
  }, []);
  return { me, denied };
}

export const OsStatusBadge = ({ status }) => (
  <span className={`px-2.5 py-0.5 text-xs font-semibold rounded-sm border ${OS_STATUS_STYLE[status] || ""}`}>
    {OS_STATUS_LABEL[status] || status}
  </span>
);

export const OsDenied = () => (
  <div className="max-w-xl mx-auto py-20 text-center" data-testid="os-denied">
    <h2 className="text-xl font-semibold text-zinc-900" style={{ fontFamily: "Outfit" }}>Ingen OS-behörighet</h2>
    <p className="mt-2 text-sm text-zinc-600">Ditt konto saknar en OS-identitet. Kontakta din administratör.</p>
  </div>
);
